import {
  Box,
  Flex,
  Image,
  useBreakpointValue,
  // IconButton
} from '@chakra-ui/react'
// import { Research } from 'components/icons'
import { UserButton } from 'components/navbarItems'
import SearchInput from './components/SearchInput'

export default function Navbar() {
  const isMobile = useBreakpointValue({ base: true, sm: true, md: false })

  if (isMobile) {
    return (
      <Box
        h="100px"
        w="100%"
        zIndex={999}
        px={[2, 2, 6]}
        bg="bgContent"
        borderBottom={'1px solid'}
        borderColor={'borderColor'}
        pos={'absolute'}
        top={0}
      >
        <Flex h="50px" justifyContent={'space-between'} alignItems="center" gap={[2, 2, 6]}>
          <Flex flexShrink={0} mr={4} alignItems={'center'} pt={2}>
            <Image
              src="https://app.milanote.com/media/p/images/1TxS1W1Ha3Xb41/i8h/Variante3_PNG.png?v=2&elementId=1TxS1W1Ha3Xb41"
              alt=""
              h={['32px', '32px', '58px']}
              w="auto"
            />
          </Flex>
          <Flex>
            <UserButton />
          </Flex>
        </Flex>
        <Flex h="40px" >
          <SearchInput />
        </Flex>
      </Box>
    )
  }

  return (
    <Flex
      h="50px"
      w="100%"
      zIndex={999}
      justifyContent={'space-between'}
      alignItems="center"
      px={[2, 2, 6]}
      gap={[2, 2, 6]}
      bg="bgContent"
      borderBottom={'1px solid'}
      borderColor={'borderColor'}
      pos={'absolute'}
      top={0}
    >
      <Flex flexShrink={0} mr={4} alignItems={'center'} pt={2}>
        <Image
          src="https://app.milanote.com/media/p/images/1TxS1W1Ha3Xb41/i8h/Variante3_PNG.png?v=2&elementId=1TxS1W1Ha3Xb41"
          alt=""
          h={['32px', '32px', '58px']}
          w="auto"
        />
      </Flex>
      <Flex>
        <SearchInput />
      </Flex>
      <Flex>
        <UserButton />
      </Flex>
      {/* <Flex flexShrink={0} alignItems="center" gap={4}>
        <ModulesButton>
          <IconButton aria-label="Botão para navegar entre os modulos" colorScheme="primary" icon={<Research />} />
        </ModulesButton>
        <Flex overflow="hidden">
          <UserButton />
        </Flex>
      </Flex> */}
    </Flex>
  )
}
